// extracted by mini-css-extract-plugin
export default {"WorkOrderPriceKC2VolumeEdit":"WorkOrderPriceKC2VolumeEdit_WorkOrderPriceKC2VolumeEdit__eMFHf"};